// extracted by mini-css-extract-plugin
export default {"root":"authorize-required_root__yvLNs","title":"authorize-required_title__hgarR","actions":"authorize-required_actions__Y62nS"};